import {useEffect} from "react";

const useCaptureFace = (captureFace: boolean, capture: Function) => {
    useEffect(() => {
        console.log("Capture Face was updated");
        if (captureFace) {
            console.log("Capture face is true, triggering capture.");
            capture();
        }
    }, [captureFace]);
}

export default useCaptureFace;